export default {
  pagination: {
    prev: 'Previous project',
    next: 'Next project',
  },
};
